import PendingProductChanges from './PendingProductChanges';

export default PendingProductChanges;
